import { ProjectDocumentsScrollTable } from "Components/ProjectDocumentsScrollTable";
import { CollectionFolderFile } from "./interfaces";

interface ProjectFilesTableProps {
  initialValue?: API_FileDataEntity[] | CollectionFolderFile[];
  onAddFiles: (files: API_FileDataEntity[] | CollectionFolderFile[]) => void;
  onBack: () => void;
}

export const ProjectFilesTable = ({ onBack, initialValue, onAddFiles }: ProjectFilesTableProps) => {
  // tslint:disable-next-line: max-line-length
  const checkboxProps = (record: API_FileDataEntity) => ({
    disabled: record.type === "FOLDER" || initialValue.findIndex((item) => item.id === record.id) !== -1,
  });
  return (
    <ProjectDocumentsScrollTable
      onCancel={onBack}
      onAddFiles={onAddFiles}
      getCheckboxProps={checkboxProps}
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      initialValue={initialValue as any}
    />
  );
};
